import React, { useState } from "react";
import { useNavigate } from "react-router";

// Material UI
import { Box } from '@arredo/reactjs-ui'
import Grid from '@mui/material/Grid'
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Icons
import Save from "@mui/icons-material/Save";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

// Components
import ArchingTotals from "../totals";
import Spinner from "../../../components/spinner";
import ModalSuccess from "../../../components/modal/submit";
import { cashTypesFormat } from "../../../models/CashRegisterMovementEntity";

// Hooks
import useNotify from "../../../hooks/notify";
import useTotals from "../../../hooks/cashRegisters/useTotals";
import useCashRegister from "../../../hooks/cashRegisters/useCashRegister";

// Utils
import { utils } from "../../../utils/utils";
import { Authenticate } from "../../authentication";

const CreateArching = () => {
    const navigate  = useNavigate();
    const { Notify, variants } = useNotify();
    const { cashRegister } = useCashRegister();
    const { totals, loading, createArching } = useTotals(cashRegister?.id);
    const [submitOpen, setSubmitOpen] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false)
    const [archingDetails, setArchingDetails] = useState(
        Object.keys(cashTypesFormat).reduce((acum, curr) => ({
            ...acum,
            [curr]: {
                total: 0,
                real: ''
            }
        }), {})
    );
    const [account, setAccount] = useState(null);

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (!utils.ValidateValueIsString(value))
            if (value >= 0) {
                setArchingDetails({
                    ...archingDetails,
                    [event.target.name]: {
                        total: totals[event.target.name] ? totals[event.target.name].total : 0,
                        real: value,
                        currencyPrice: totals[event.target.name] ? totals[event.target.name].price : 1,
                        lastClosureAmount: totals[event.target.name] ? totals[event.target.name].lastClosureAmount : 0
                    }
                })
            }
    }

    const handleSave = async () => {
        if (totals.fullTotal < 0)
            return Notify(`No se puede guardar un arqueo cuando el total de caja es nagativo`, variants.ERROR);

        setSubmitOpen(true);
        const res = !!(await createArching(archingDetails, account.username));
        setSuccess(res);
        setError(!res);
    }

    const handleLogin = async (account) => {
        try {
            const response = await Authenticate()
            if (!response.account)
                throw new Error("Error al intentar realizar el logueo");

            setAccount(response.account);
        } catch (err) {
            console.error(err);
            Notify("Error al intentar realizar la arqueo de caja", variants.ERROR);
        }
    }

    const handleError = async (event) => {
        setSubmitOpen(false);
        setSuccess(false);
        setError(false);
        Notify("Error al intentar realizar la arqueo de caja", variants.ERROR);
    }

    return (
        <>
            <ModalSuccess
                open={submitOpen}
                success={success}
                error={error}
                successText="Arqueo creado con éxito"
                onSuccess={() => navigate(`/cashRegisters/archings`)}
                errorText="No se pudo crear el arqueo"
                onError={handleError}
            />
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Box
                        header={
                            <Typography variant='h4'>
                                {`Nuevo Arqueo: ${cashRegister.name}`}
                            </Typography>
                        }
                        actions={
                            account &&
                            <>
                                <AssignmentIndIcon fontSize='large' />
                                <Typography variant='h5'>{account.name}</Typography>
                            </>
                        }
                    />
                </Grid>
                {
                    loading &&
                    <Grid size={12}>
                        <Spinner message='Cargando' />
                    </Grid>
                }
                {
                    !loading &&
                    <Grid size={12}>
                        <ArchingTotals
                            totals={totals}
                            detail={archingDetails}
                            onInputChange={handleInputChange}
                        />
                    </Grid>
                }
                <Grid size={12}>
                    <Box
                        header={
                            <Grid display='flex' justifyContent='space-between'>
                                <Button
                                    disabled={loading}
                                    variant='contained'
                                    color='primary'
                                    size='large'
                                    startIcon={<ArrowBackIos />}
                                    onClick={() => navigate(-1)}
                                >
                                    Volver
                                </Button>
                                {
                                    !account &&
                                    <Button
                                        disabled={loading}
                                        variant='contained'
                                        color='primary'
                                        size='large'
                                        startIcon={<AssignmentIndIcon />}
                                        onClick={handleLogin}
                                    >
                                        Registrar Usuario
                                    </Button>
                                }
                                {
                                    account &&
                                    <Button
                                        disabled={loading}
                                        variant='contained'
                                        color='primary'
                                        size='large'
                                        startIcon={<Save />}
                                        onClick={handleSave}
                                    >
                                        Guardar arqueo
                                    </Button>
                                }
                            </Grid>
                        }
                    />

                </Grid>
            </Grid>
        </>
    );
}

export default CreateArching;